var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-image-preview',{attrs:{"startPosition":_vm.startPosition,"images":_vm.imgList},on:{"change":_vm.change},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }